import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {filter, map, withLatestFrom} from 'rxjs/operators';
import {PAGE_DATEN_LADEN, PageLoadDataAction} from './dokumente.actions.ui';
import {GetVeranstaltungDokumenteAction} from '../../../../client-ngrx/veranstaltungen';
import {getAktuelleVeranstaltung} from '../../app-state/app-state.reducer';
import {Dokument, Veranstaltung} from '../../../../clients/veranstaltungen';
import {AKTUELLE_VERANSTALTUNG_SETZEN, AktuelleVeranstaltungSetzenAction} from '../../app-state/actions/veranstaltung.actions';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {VorlagenEntityTypes} from '../../../../client-constants';
import DOKUMENT_ENTITY = VorlagenEntityTypes.DOKUMENT_ENTITY;

@Injectable()
export class DokumentePageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(PAGE_DATEN_LADEN),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [PageLoadDataAction, Veranstaltung]) => aktuelleVeranstaltung !== null),
        map(([x, aktuelleVeranstaltung]: [PageLoadDataAction, Veranstaltung]) =>
            new GetVeranstaltungDokumenteAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    @Effect()
    aktuelleVeranstaltungSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(AKTUELLE_VERANSTALTUNG_SETZEN),
        map((x: AktuelleVeranstaltungSetzenAction) => x),
        filter(x => x.payload != null),
        map(x => x.payload),
        filter(x => x.veranstaltung_id != null),
        map((x) =>
            new GetVeranstaltungDokumenteAction(x.veranstaltung_id)
        )
    );

    @Effect()
    wsDokumente$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === DOKUMENT_ENTITY;
        }),
        map((x) => <Dokument> JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [Dokument, Veranstaltung]) => aktuelleVeranstaltung !== null),
        filter(([x, aktuelleVeranstaltung]: [Dokument, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
        map(([x, aktuelleVeranstaltung]: [Dokument, Veranstaltung]) =>
            new GetVeranstaltungDokumenteAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }
}
